export default class LocalStorage {
  static setItem(key: string, value: any) {
    if (!key || !value) return false;
    localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : value);
    return true;
  }

  static getItem(key: string) {
    if (!key) return null;
    const value = localStorage.getItem(key);

    if (!value) return null;

    let parsedValue;
    try {
      parsedValue = JSON.parse(value);
    } catch (e) {}
    return parsedValue || value;
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
